<template>
<div class="contact-list-cell-renderer-contact">
    <div>{{ contactName }}</div>
    <div v-if="gpMqIsMobile">{{ contactPhone }}</div>
</div>
</template>

<script>
export default {
  name: 'ContactListCellRendererContact',
  computed: {
    contactData() {
      return this.params && this.params.data
        ? this.params.data
        : null;
    },
    contactName() {
      return this.contactData
        ? this.contactData.name
        : '';
    },
    contactPhone() {
      return this.contactData
        ? this.contactData.phoneInternational
        : '';
    },
  },
};
</script>

<style scoped lang="scss">
.contact-list-cell-renderer-contact {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    row-gap: 8px;

    div {
        line-height: 1;
    }
}
</style>
